"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppEventSubtypes = exports.IntegrationsEventSubtypes = exports.EventTypes = void 0;
var EventTypes;
(function (EventTypes) {
    EventTypes["PROVIDER_WEBHOOK"] = "provider_webhook";
    EventTypes["SUMSUB_WEBHOOK"] = "sumsub_webhook";
    EventTypes["COMPLY_ADVANTAGE_RESULT"] = "comply_advantage_result";
    EventTypes["PROVIDER_INITIATION"] = "provider_initiation";
    EventTypes["INTEGRATIONS_WEBHOOK"] = "integrations_webhook";
    EventTypes["OTHER"] = "other";
    EventTypes["EXTERNAL_APP"] = "external_app";
})(EventTypes = exports.EventTypes || (exports.EventTypes = {}));
var IntegrationsEventSubtypes;
(function (IntegrationsEventSubtypes) {
    IntegrationsEventSubtypes["INITIAL_SYNC"] = "initial_sync";
    IntegrationsEventSubtypes["AUTHORIZATION"] = "authorization";
    IntegrationsEventSubtypes["PRODUCT_CREATED"] = "product_created";
    IntegrationsEventSubtypes["PRODUCT_DELETED"] = "product_deleted";
    IntegrationsEventSubtypes["PRODUCT_UPDATED"] = "product_updated";
    IntegrationsEventSubtypes["CUSTOMER_CREATED"] = "customer_created";
    IntegrationsEventSubtypes["CUSTOMER_UPDATED"] = "customer_updated";
    IntegrationsEventSubtypes["CUSTOMER_DELETED"] = "customer_deleted";
    IntegrationsEventSubtypes["ORDER_CREATED"] = "order_created";
    IntegrationsEventSubtypes["ORDER_UPDATED"] = "order_updated";
    IntegrationsEventSubtypes["ORDER_DELETED"] = "order_deleted";
})(IntegrationsEventSubtypes = exports.IntegrationsEventSubtypes || (exports.IntegrationsEventSubtypes = {}));
var AppEventSubtypes;
(function (AppEventSubtypes) {
    AppEventSubtypes["INITIAL_SYNC"] = "initial_sync";
    AppEventSubtypes["AUTHORIZATION"] = "authorization";
    AppEventSubtypes["PRODUCT_CREATED"] = "product_created";
    AppEventSubtypes["PRODUCT_DELETED"] = "product_deleted";
    AppEventSubtypes["PRODUCT_UPDATED"] = "product_updated";
    AppEventSubtypes["CUSTOMER_CREATED"] = "customer_created";
    AppEventSubtypes["CUSTOMER_UPDATED"] = "customer_updated";
    AppEventSubtypes["CUSTOMER_DELETED"] = "customer_deleted";
    AppEventSubtypes["ORDER_CREATED"] = "order_created";
    AppEventSubtypes["ORDER_UPDATED"] = "order_updated";
    AppEventSubtypes["ORDER_DELETED"] = "order_deleted";
    AppEventSubtypes["APP_UPDATE"] = "app_update";
    AppEventSubtypes["APP_DELETION"] = "app_deletion";
    AppEventSubtypes["APP_DEACTIVATION"] = "app_deactivation";
})(AppEventSubtypes = exports.AppEventSubtypes || (exports.AppEventSubtypes = {}));
